<div>
  <div class="px-xs pt-xxs">
    <div class="w-full mb-xxs flex align-center">
      <h1 class="cui-h1" id="main-content-header" tabindex="-1">
        Initial Claim Report
      </h1>
      <div class="grow"></div>
    </div>
  </div>
  <main
    *ngIf="dataItems && dataItems.length > 0; else shortLoadBlock"
    class="mx-xs mb-xs container"
    (scroll)="dataScroll($event)"
    id="report-container"
  >
    <nav aria-label="Report navigation">
      <ng-container>
        <icr-report-nav [data]="dataItems"></icr-report-nav>
      </ng-container>
    </nav>
    <section aria-label="Report data">
      <icr-report-data class="w-64" [data]="dataItems"></icr-report-data>
    </section>
  </main>
  <ng-template #shortLoadBlock>
    <div class="short-block">Loading inital report...</div>
  </ng-template>
</div>
